import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'submit',
    templateUrl: './input.submit.component.html'
})
export class SubmitComponent {
    /**
     * Should the button be disabled or not
     */
    @Input() disabled: boolean;

    /**
     * Text for the button
     */
    @Input() text: string;

    /**
     * Should the button have an arrow to the right
     */
    @Input() arrow: boolean;

    /**
     * Additional css classes as string
     * @type {string}
     */
    @Input() additionalClasses: string = '';

    /**
     * Optional hint text shown below the button
     * @type {string}
     */
    @Input() secureText: string = '';

    /**
     * Class for an icon that should be shon in the button
     * @type {any}
     */
    @Input() icon: string = null;

    /**
     * value for the aria-live attribute
     */
    @Input() ariaLive: string = null;

    /**
     * returns the set of css classes for the button
     *
     * @returns {string}
     */
    getClasses(): string {
        let classes = 'button';
        if (this.arrow) {
            classes += ' arrow';
        }
        if (this.additionalClasses) {
            classes += ' ' + this.additionalClasses;
        }
        if (this.secureText) {
          classes += ' has-hint' ;
        }
        return classes;
    }

}
